var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewInspResults(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    alt: "eApproval Inspection Results",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eApproval"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.56,40.54l-4.73-5.23a4.25,4.25,0,0,1-1.09-2.84V25.05a14.26,14.26,0,0,0-11.49-14V8.77a2.62,2.62,0,0,0-5.07-.95A14.49,14.49,0,1,0,14.5,29.3c.34,0,.67,0,1-.05v3.22a4.21,4.21,0,0,1-1.1,2.84L9.68,40.54A1.69,1.69,0,0,0,11,43.36H23.41a6.44,6.44,0,0,0,6.21,6.34,6.42,6.42,0,0,0,6.21-6.34H48.27A1.69,1.69,0,0,0,49.56,40.54ZM13.24,22.64a1,1,0,0,1-.64.45.76.76,0,0,1-.21,0,1,1,0,0,1-.56-.17l-7-4.66a1,1,0,0,1-.27-1.39A1,1,0,0,1,6,16.63l6.13,4.08L21.15,6a1,1,0,0,1,1.38-.32,1,1,0,0,1,.32,1.37ZM29.47,47.2a4.06,4.06,0,0,1-3.95-4.06.5.5,0,0,1,1,0,3.09,3.09,0,0,0,2.95,3.06.5.5,0,0,1,.5.5A.5.5,0,0,1,29.47,47.2Zm.15-5.84h-18l4.25-4.71a6.19,6.19,0,0,0,1.62-4.18V24.66A12,12,0,0,1,29.62,12.81l.59,0A12.15,12.15,0,0,1,41.74,25.05v7.42a6.23,6.23,0,0,0,1.61,4.18l4.26,4.71Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewInspResults);
export default __webpack_public_path__ + "static/media/ViewInspResults.d13f57c1.svg";
export { ForwardRef as ReactComponent };